import React, { useState } from 'react'

export const useFilterDataOderBy = (data, orderBy) => {
  const [newerOrOlder, setNewerOrOlder] = useState('')

  function compare(a, b) {
    const option = {
      older: 'older',
      newer: 'newer',
    }

    if (newerOrOlder === option.older) {
      //se enao tiver data,ou da ta estiver errada, vai pro final da lista
      if (!a[orderBy] || !b[orderBy]) return 1

      return new Date(b[orderBy]) - new Date(a[orderBy])
    } else if (newerOrOlder === option.newer) {
      //se enao tiver data,ou da ta estiver errada, vai pro final da lista
      if (!a[orderBy] || !b[orderBy]) return -1
      return new Date(a[orderBy]) - new Date(b[orderBy])
    }

    return 0
  }
  const memoizedCompare = React.useCallback(compare, [newerOrOlder, orderBy])

  const filteredData = React.useMemo(() => {
    if (!data) return []

    return data?.sort(memoizedCompare)
  }, [data, memoizedCompare])

  return { filteredData, newerOrOlder, setNewerOrOlder }
}

//usage example

// import { useFilterDataOderBy } from "./hooks/useFilterDataOderBy";

// export function Component() {
//   const { filteredData, newerOrOlder, setNewerOrOlder } = useFilterDataOderBy(data, "data");

//   return (
//     <>
//       <button onClick={() => setNewerOrOlder("older")}>older</button>
//       <button onClick={() => setNewerOrOlder("newer")}>newer</button>
//     </>
//   );
// }
